import React from 'react';
import Moment from 'moment';
import styles from './CalendarFilter.module.css';
import backArrowRight from '../../../../assets/images/Fireboard/black_Arrow_right.png';
import backArrowLeft from '../../../../assets/images/Fireboard/black_arrow_left.png';
import closeIcon from '../../../../assets/images/Fireboard/close.png';

export interface CalendarFilterProps {
  selectedDate: any;
  onDateChange: Function;
  resetFilterCalendar: Function;
  onlineOrderAdvanceLimit?: Number;
}

const CalendarFilter = ({ selectedDate, onDateChange, resetFilterCalendar, onlineOrderAdvanceLimit = 1 }: CalendarFilterProps) => {

  const formatDate = () => {
    if (selectedDate) {
      return Moment(selectedDate).format('MM/DD/YYYY');
    }
  }

  const incrementDate = () => {
    const minDate = Moment(new Date().setHours(0, 0, 0, 0)).add(1, 'day').toDate();
    const maxDate = Moment(minDate).add(onlineOrderAdvanceLimit - 1, 'days').toDate();
    const incrementDate = Moment(selectedDate).add(1, 'days');
    if (incrementDate.isSameOrBefore(Moment(maxDate))) {
      onDateChange(incrementDate);
    }
  };

  const decrementDate = () => {
    const decrementedDate = Moment(selectedDate).subtract(1, 'days');
    const currentDate = Moment(new Date().setHours(0, 0, 0, 0));
    if (Moment(currentDate).isSameOrBefore(decrementedDate)) {
      onDateChange(decrementedDate);
    }
  };

  return (
    <div className={styles.container}>
      <span className={styles.heading}>*FUTURE</span>
      <div className={styles.dateNavigator}>
        <img onClick={decrementDate} src={backArrowLeft} className={styles.arrowIcon} alt="" />
        <span className={styles.date}>{formatDate()}</span>
        <img onClick={incrementDate} src={backArrowRight} className={styles.arrowIcon} alt="" />
      </div>
      <img onClick={resetFilterCalendar} src={closeIcon} className={styles.resetIcon} alt="" />
    </div>
  );
}

export default CalendarFilter;
